import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogActions } from '../Dialog/Dialog';
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { logoutUser } from "../../../store/actions/authActionCreators";
import { withRouter, useHistory } from 'react-router-dom';
import useStyles from '../../pages/css/forms';
import { type } from 'jquery';
import { driverAdditionType, driverDeductionType, addReduceDriverTransaction, driverAddTranscationType, editSingleDriverTransaction } from "../../../store/actions/vehicleActionCreator";
import NotesIcon from '@material-ui/icons/Notes';
import DateFnsUtils from '@date-io/date-fns';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Divider from '@material-ui/core/Divider';
import * as logger from '../../../logger';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { getDriverLedger, getSparklineTotalBalances } from '../../../store/actions/homeActionCreator';
import { DialogTitle } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { replaceCommas, numberWithCommas, checkNumberOnly, numberWithCommasInput } from '../../../utils/utils';
import AmountInput from '../Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';

// function sleep(delay = 0) {
//     return new Promise((resolve) => {
//         setTimeout(resolve, delay);
//     });
// }

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const filter = createFilterOptions();

const DriverGaveAndGot = ({ props, defaultName, fromSingleDriver, dispatchEditTransaction, balanceType, dispatchAddDriverTransactions, dispatchFetchAllDrivers, dispatchGetDriverAdditionTypes, dispatchGetDriverDeductionTypes, onConfirm, onOpen, onClose, onSave, vehicle, dispatchAddNewDriver, driverId, fromDriverListing, user, dispatchAddTransactionType, onEdit, dispatchGetSparklineBalances }) => {

    let submit;
    const [driverAdditionTypeList, setDriverAdditionTypeList] = useState([]);
    const [driverDeductionTypeList, setDriverDeductionTypeList] = useState([]);
    const [dialogopen, setDialogOpen] = React.useState(onOpen);
    const [open, setOpen] = React.useState(false);
    const [addDriverOpen, toggleAddReasonOpen] = React.useState(false);
    const [reasonValue, setReasonValue] = useState("");
    const [recall, setRecall] = useState(false);
    const [singleTransactionData, setSingleTransactionData] = useState({});
    const [disable, setDisable] = useState(false);
    const [amountValue, setAmountValue] = useState('');
    const [notesValue, setNotesValue] = useState("");
    const [dateValue, setDateValue] = useState(new Date());

    const initialValues = {
        date: dateValue,
        amount: numberWithCommas(amountValue),
        reason: reasonValue,
        note: notesValue
    }

    const classes = useStyles();

    useEffect(() => {
        if (balanceType == "driverGave") {
            dispatchGetDriverDeductionTypes(
                null,
                () => {
                },
                () => {
                }
            );
        } else if (balanceType == "driverGot") {
            dispatchGetDriverAdditionTypes(
                null,
                () => {
                },
                () => {
                }
            );
        }
    }, [onOpen, onEdit]);

    useEffect(() => {

        let finalList = [];

        if (balanceType == "driverGave") {
            finalList = vehicle && vehicle.driverDeductionTypes && vehicle.driverDeductionTypes.recentlyUsed ? vehicle.driverDeductionTypes.recentlyUsed.concat(vehicle.driverDeductionTypes.recommended) : [];
            setDriverDeductionTypeList(vehicle && vehicle.driverDeductionTypes ? finalList : []);
        } else if (balanceType == "driverGot") {
            finalList = vehicle && vehicle.driverAdditionTypes && vehicle.driverAdditionTypes.recentlyUsed ? vehicle.driverAdditionTypes.recentlyUsed.concat(vehicle.driverAdditionTypes.recommended) : [];
            setDriverAdditionTypeList(vehicle && vehicle.driverAdditionTypes ? finalList : [])
        }

    }, [vehicle.driverDeductionTypes, vehicle.driverAdditionTypes]);


    useEffect(() => {

        if (onEdit) {
            setSingleTransactionData(vehicle.singleDriverTransaction);

            const transactInfo = vehicle && vehicle.singleDriverTransaction ? vehicle.singleDriverTransaction : {}
            setAmountValue(transactInfo && transactInfo.amount ? transactInfo.amount : 0);
            setReasonValue(transactInfo && transactInfo.displayName ? transactInfo.displayName : "");
            setNotesValue(transactInfo && transactInfo.description ? transactInfo.description : "")
            setDateValue(transactInfo && transactInfo.transactionDate ? new Date(transactInfo.transactionDate * 1000) : new Date())

            if (vehicle.singleDriverTransaction.vehicleInfo?.id || vehicle.singleDriverTransaction.tripInfo?.id) {
                setDisable(true)
            }
        }

    }, [vehicle.singleDriverTransaction, onEdit]);

    if (onEdit) {
        if (balanceType == 'driverGave') {
            let findDeduction = driverDeductionTypeList.indexOf(vehicle.singleDriverTransaction.displayName);
            if (findDeduction == -1) {
                driverDeductionTypeList.push(vehicle.singleDriverTransaction.displayName);
            }
        }

        if (balanceType == 'driverGot') {
            let findAddition = driverAdditionTypeList.indexOf(vehicle.singleDriverTransaction.displayName);
            if (findAddition == -1) {
                driverAdditionTypeList.push(vehicle.singleDriverTransaction.displayName);
            }
        }
    }

    // useEffect(() => {

    //     if (fromDriverListing || fromSingleDriver) {
    //         setSingleTransactionData({ transactionDate: new Date(), amount: "", reason: "", note: "" });
    //     }

    // }, [dialogopen])


    const reasonType = [
        {
            size: 6,
            field: (
                <Autocomplete
                    classes={{
                        listbox: classes.listBoxAutoCompelete,
                        option: classes.listBoxOption
                    }
                    }
                    id="select-reason-type-list"
                    //label="Party"
                    name="reason"
                    size="small"
                    //placeholder="Select a Party"
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    onChange={(event, newValue) => {

                        let newTypeValue = newValue ? newValue.toString() : "";

                        if (typeof newTypeValue === 'string') {

                            // timeout to avoid instant validation of the dialog's form.
                            setTimeout(() => {
                                toggleAddReasonOpen(true);
                                setReasonValue(newValue);
                            });
                        } else if (newValue) {
                            toggleAddReasonOpen(true);
                            setReasonValue(newValue);
                        } else if (newValue === '') {
                            toggleAddReasonOpen(true);
                            setReasonValue(newValue);
                        } else {
                            setReasonValue(newValue);
                        }
                    }}
                    getOptionSelected={(option, value) => option === value}
                    required={true}
                    autoHighlight
                    freeSolo
                    options={balanceType == 'driverGave' ? (driverDeductionTypeList ? driverDeductionTypeList : []) : (driverAdditionTypeList ? driverAdditionTypeList : [])}
                    selectOnFocus
                    clearOnBlur
                    disabled={disable}
                    handleHomeEndKeys
                    getOptionValue={option => option.replace(/\'/g, "")}
                    getOptionLabel={(option) => {
                        // e.g value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option.replace(/\'/g, "");
                        }
                        if (option) {
                            return option.replace(/\'/g, "");
                        }
                        return option.replace(/\'/g, "")
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        if (params.inputValue !== '') {
                            filtered.unshift(
                                `'${params.inputValue}'`,
                            );
                        }

                        return filtered;
                    }}
                    renderOption={(option, params) => {
                        if (params.inputValue !== '' && option.toString().includes("\'")) {
                            return (
                                <>
                                    <div className={classes.divV1} onClick={() => handleAddNewTransaction(option.toString())}>
                                        <div className={classes.divV2}>
                                            <div>
                                                <ReceiptIcon className={classes.receiptIcon} />
                                            </div>
                                            <div className={classes.divV3}>
                                                <div className={classes.divV4} >{option.toString()}</div>
                                                <div className={classes.divV5}>Tap to add reason</div>
                                            </div>
                                        </div>
                                        <ChevronRightIcon className={classes.cherveRightIcon} />
                                    </div>
                                </>
                            );
                        } else {
                            return (

                                <div className={classes.divV6}>
                                    {option.toString()}
                                </div>


                            );
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // label="Enter Reason"
                            placeholder="Enter Reason"
                            variant="outlined"
                            name="reason"
                            margin='normal'
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                    multiple={false}
                />
            ),
        }
    ]

    const handleAddNewTransaction = (newTransaction) => {
        let newTransactionType = newTransaction.toString();

        var data = {
            name: newTransactionType ? (newTransactionType.replace(/\'/g, "")).trim() : ""
        }

        if (balanceType == "driverGave") {
            data.type = "DEDUCTION"
        } else if (balanceType == "driverGot") {
            data.type = "ADDITION"
        }

        dispatchAddTransactionType(data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Gave and Got Component", 'Add transaction type successfull');
                    if (balanceType == "driverGave") {
                        dispatchGetDriverDeductionTypes(
                            null,
                            () => {
                            },
                            () => {
                            }
                        );
                    } else if (balanceType == "driverGot") {
                        dispatchGetDriverAdditionTypes(
                            null,
                            () => {
                            },
                            () => {
                            }
                        );
                    }
                }
            },
            () => {
                logger.log("Driver Gave and Got Component", 'Add transaction type failed');
            }
        );
    }

    const handleClose = (status) => {
        onClose(false);
        var form = document.getElementById('myForm');
        form.reset();
    };

    const onSubmit = async values => {

        await sleep(300);

        if (onEdit) {

            var data = {
                driverId: driverId,
                amount: replaceCommas(values.amount),
                transactionDate: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                type: values.reason ? values.reason.replace(/\'/g, "") : "",
                description: values.note,
            }

            let id;

            if (singleTransactionData && singleTransactionData.id) {
                id = singleTransactionData.id
            }

            if (singleTransactionData && singleTransactionData.tripInfo && singleTransactionData.tripInfo.id) {
                data.driverToPay = true
            }

            dispatchEditTransaction(id,
                data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Single Driver Component", "Edit Driver transaction successfull");
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Single Driver Component", "Edit Driver transaction failed");
                }
            )

        } else {
            const driverLedgerRequestData = {
                fleetOwnerId: user.userInfo.entityId,
                // pageNo: 1,
                // pageSize: 10,
            };

            var data = {
                driverId: driverId,
                amount: replaceCommas(values.amount),
                transactionDate: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                description: values.note,
                type: values.reason ? values.reason.replace(/\'/g, "") : ""
            }

            if (balanceType == "driverGave") {
                data.driverToPay = false
            } else if (balanceType == "driverGot") {
                data.driverToPay = true
            }

            dispatchAddDriverTransactions(data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Driver Component Dialog Dweb ", "Successfull");
                        setDialogOpen(false);
                        if (fromSingleDriver) {
                            onConfirm();
                        }
                        if (fromDriverListing) {
                            dispatchFetchAllDrivers(driverLedgerRequestData,
                                () => {
                                    logger.log("Drivers dWeb", "Fetch all drivers successfull");

                                    dispatchGetSparklineBalances(
                                        () => {
                                            logger.log("Drivers dWeb", "Get Sparkline Balances Successfull");
                                            onClose(false);
                                        },
                                        () => {
                                            logger.log("Drivers dWeb", "Get Sparkline Balances Failed");
                                        }
                                    )

                                },
                                () => {
                                    logger.log("Drivers dWeb", "Fetch all drivers failed");
                                },
                            );
                        }
                    }
                },
                () => {
                    logger.log("Driver Component Dialog Dweb", "Failed");
                }
            );
        }
    }


    const validate = async values => {

        await sleep(100)

        const errors = {};

        if (values.amount && !checkNumberOnly(replaceCommas(values.amount)) || !values.amount) {
            errors.amount = "Please enter valid amount"
        }
        if (!values.reason) {
            errors.reason = "Please enter reason"
        }
        if (!values.date) {
            errors.date = "Please select date"
        }

        return errors;
    }

    // const handleCloseDialog = (event) => {
    //     event.preventDefault();
    //     setDialogOpen(false);
    //     onClose(false);
    // }

    return (
        <Dialog fullWidth={true}
            maxWidth='xs'
            onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogopen}>
            <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                <div className={classes.divV20}>
                    {balanceType == "driverGave" &&
                        < div > Driver Gave(-) </div>
                    }
                    {balanceType == "driverGot" &&
                        < div > Driver Got(+) </div>
                    }
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent dividers className={classes.dialogContentV1}>
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validate}
                    render={({ handleSubmit, form, submitting, pristine, values }) => {
                        submit = handleSubmit
                        return (
                            <form
                                onSubmit={(event) => {
                                    const promise = handleSubmit(event);
                                    // promise && promise.then(() => {
                                    //     form.reset();
                                    // })
                                    return promise;
                                }} id="myForm" noValidate>
                                <div className={classes.divAmount} >Amount*</div>
                                <AmountInput
                                    // label="Amount"
                                    placeholder="Amount"
                                    name="amount"
                                    variant="outlined"
                                    size="small"
                                    required={true}
                                    onChange={(e) => { setAmountValue(e.target.value) }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end"> &#x20B9;</InputAdornment>,
                                    }}
                                    fieldProps={{
                                        // parse: value => value && numberWithCommas(value)
                                    }}
                                    className={classes.marginV1}
                                />

                                <div className={classes.divReason}>Reason</div>
                                {reasonType.map((item, idx) => (
                                    item.field
                                ))}

                                <div className={classes.divDate}>Date</div>
                                <DatePicker
                                    disableFuture
                                    name="date"
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    format="dd-MM-yyyy"
                                    // label="Date"
                                    placeholder="Select Date"
                                    dateFunsUtils={DateFnsUtils}
                                    InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                    className={classes.marginV1}
                                    onChange={(date) => setDateValue(date)}
                                />

                                <div style={{ color: '#9ea0a5', fontSize: 12, fontWeight: 500, marginTop: 18 }}>Notes</div>
                                <TextField
                                    // label="Note"
                                    placeholder="Notes"
                                    name="note"
                                    margin="none"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>,
                                    }}
                                    helperText={"Optional"}
                                    className={classes.marginV1}
                                    onChange={(e) => setNotesValue(e.target.value)}
                                />

                                <Divider className={classes.mtV1} />

                            </form>
                        )
                    }}
                />

                {/* <Button color="primary" onClick={() => {
                    document.getElementById('myForm')
                        .dispatchEvent(new Event('submit', { cancelable: true }))
                }}>Submit</Button> */}

                <div className={classes.divV7}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </div>

            </DialogContent>
        </Dialog>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetDriverAdditionTypes: (onSuccess, onFailure) => {
        dispatch(driverAdditionType(onSuccess, onFailure))
    },
    dispatchGetDriverDeductionTypes: (onSuccess, onFailure) => {
        dispatch(driverDeductionType(onSuccess, onFailure));
    },
    dispatchAddDriverTransactions: (data, onSuccess, onFailure) => {
        dispatch(addReduceDriverTransaction(data, onSuccess, onFailure))
    },
    dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedger(data, onSuccess, onFailure))),
    dispatchAddTransactionType: (data, onSuccess, onFailure) => {
        dispatch(driverAddTranscationType(data, onSuccess, onFailure));
    },
    dispatchEditTransaction: (id, data, onSuccess, onFailure) => {
        dispatch(editSingleDriverTransaction(id, data, onSuccess, onFailure))
    },
    dispatchGetSparklineBalances: (onSuccess, onFailure) => {
        dispatch(getSparklineTotalBalances(onSuccess, onFailure))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriverGaveAndGot);
